import { useParams } from "react-router-dom";
import React from "react";
import PageHeader from "@/custolink-views/asset_frontend/ui/layout/PageHeader";
import VerifyEmailSharedForm from "@/custolink-components/shared/VerifyEmailSharedForm";
import PageContent from "@/custolink-views/asset_frontend/ui/layout/PageContent";
import { useAssetFrontendDesign } from "@/custolink-views/asset_frontend/redesigns/assetFrontendDesign";
import VerifyEmailForEndUserDesign from "@/custolink-views/end_user/VerifyEmailForEndUserDesign";

export default function VerifyEmailForEndUser() {
  const { token } = useParams();
  const newDesign = useAssetFrontendDesign();

  if (newDesign) {
    return <VerifyEmailForEndUserDesign />;
  }

  return (
    <>
      <PageHeader>
        <div className="flex items-center justify-between">
          <h3 className={"text-white"}>Welcome</h3>
          <div></div>
        </div>
      </PageHeader>

      <PageContent>

      <VerifyEmailSharedForm token={token as string} signInUrl={
        "/"
      } toastDesignSwitch="asset" />

      </PageContent>
    </>
  );
}
